import angular from 'angular';
import editableTextField from './editableTextField';
import './style.scss';

export default angular
  .module('editableTextField', [])
  .component('editableTextField', editableTextField).name;
